// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.empty-cabinet-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  padding: var(--space-7) var(--space-6);
  background-color: var(--color-surface-muted);
  border: 1px solid var(--color-border-subtle);
  border-radius: var(--radius-lg);
  gap: var(--space-4);
}

.empty-cabinet-state-image {
  width: min(220px, 70vw);
  height: auto;
  object-fit: contain;
  display: block;
}

.empty-cabinet-state-title {
  margin: 0;
  color: var(--color-black);
}

.empty-cabinet-state-description {
  margin: 0;
  max-width: 360px;
  color: var(--color-dark-gray);
  line-height: 1.5;
}

.empty-cabinet-state-action {
  margin-top: var(--space-2);
}

@media (max-width: 640px) {
  .empty-cabinet-state {
    padding: var(--space-6) var(--space-4);
  }

  .empty-cabinet-state-image {
    width: min(180px, 60vw);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/EmptyCabinetState/EmptyCabinetState.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,sCAAsC;EACtC,4CAA4C;EAC5C,4CAA4C;EAC5C,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,sCAAsC;EACxC;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".empty-cabinet-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  width: 100%;\n  padding: var(--space-7) var(--space-6);\n  background-color: var(--color-surface-muted);\n  border: 1px solid var(--color-border-subtle);\n  border-radius: var(--radius-lg);\n  gap: var(--space-4);\n}\n\n.empty-cabinet-state-image {\n  width: min(220px, 70vw);\n  height: auto;\n  object-fit: contain;\n  display: block;\n}\n\n.empty-cabinet-state-title {\n  margin: 0;\n  color: var(--color-black);\n}\n\n.empty-cabinet-state-description {\n  margin: 0;\n  max-width: 360px;\n  color: var(--color-dark-gray);\n  line-height: 1.5;\n}\n\n.empty-cabinet-state-action {\n  margin-top: var(--space-2);\n}\n\n@media (max-width: 640px) {\n  .empty-cabinet-state {\n    padding: var(--space-6) var(--space-4);\n  }\n\n  .empty-cabinet-state-image {\n    width: min(180px, 60vw);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
